/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import ContentLoader from "react-content-loader";
import {SkeletonSettings} from "../../../../../atoms/effects/skeletons/utils/SkeletonSettings";
import React from "react";

export const ProductRowHeaderSkeleton = (props) => (
    <ContentLoader
        height={32}
        width={"100%"}
        speed={SkeletonSettings.SPEED}
        backgroundColor={SkeletonSettings.BACKGROUND}
        foregroundColor={SkeletonSettings.FOREGROUND}
        {...props}>

        {/* Thumbnail title */}
        <rect x="0" y="12" rx="3" ry="3" width="80" height="10"/>

        {/* Packaging info */}
        <rect x="48%" y="12" rx="3" ry="3" width="8%" height="10"/>

        {/* Weight price */}
        <rect x="57%" y="12" rx="3" ry="3" width="8%" height="10"/>

        {/* Unit price */}
        <rect x="66%" y="12" rx="3" ry="3" width="8%" height="10"/>

    </ContentLoader>
);

